import { ReactNode } from 'react';

interface Props {
  title: string;
  action?: ReactNode;
  children: ReactNode;
}

const SectionBlock = ({ title, action, children }: Props) => (
  <div className="border border-border-subtle rounded-xl overflow-hidden bg-bg-surface">
    <div className="flex items-center justify-between px-4 py-3 bg-bg-surface-raised border-b border-border-subtle">
      <span className="text-sm font-medium text-text-default">{title}</span>
      {action}
    </div>
    <div className="p-4">{children}</div>
  </div>
);

export default SectionBlock;
